export enum PaymentDueOptionId {
    DueOnCompletion = 1,
    DueInAdvance = 2
  }
